import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import CenterPanelUpdate from './centerPanelUpdate';
import RightPanelTop from './rightPanelTop';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

const WARecordingSettingModal = ({
  waitingArea,
  showWAAudioSettingModal,
  updateOrView,
  isAdmin,
  updateOrInsert,
  isRecordingEnabled,
}) => {
  let centerPanel = {};
  let title = APP.LANGUAGE.Recording.TitleUpdateAndView;
  //let orgName = waitingArea ? waitingArea.organisationName : '';
  //var updatingWaitingAreaName = (waitingArea ? waitingArea.name : '') + ' (' + orgName + ')';
  //let subtitle = updatingWaitingAreaName;
  const [currentCheckboxValue, setCurrentCheckboxValue] = useState(!!isRecordingEnabled);

  useEffect(() => {
    setCurrentCheckboxValue(isRecordingEnabled);
  }, [isRecordingEnabled]);

  let rightPanel = (
    <RightPanelTop currentCheckboxValue={currentCheckboxValue} waitingArea={waitingArea} updateOrView={updateOrView} />
  );
  if (updateOrView == 'update') {
    centerPanel = (
      <CenterPanelUpdate
        setCurrentCheckboxValue={setCurrentCheckboxValue}
        currentCheckboxValue={currentCheckboxValue}
        isAdmin={isAdmin}
      />
    );
  }
  if (updateOrView == 'view') {
    centerPanel = <CenterPanelUpdate currentCheckboxValue={currentCheckboxValue} updateOrView={updateOrView} />;
  }

  return (
    <Modal
      show={showWAAudioSettingModal}
      hideWhenClickAway={false}
      className={updateOrInsert + ' waiting-area-after-call'}
    >
      <PopupHeader
        title={title}
        subtitle={waitingArea.name}
        helpLink={window.APP.EXTERNAL_LINKS.WaitingArea.HelpRecordingAudioLink}
      />
      <div className="content">
        <div className="main-ui-container">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
              <RightPanelBottom isAdmin={isAdmin} />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtl">
              {rightPanel}
              <RightPanelBottom isAdmin={isAdmin} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WARecordingSettingModal;
